import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Float']['output'];
};

export type Boolean_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildingCreateDto = {
  name: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type BuildingFloorCreateDto = {
  building_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type BuildingHierarchyUnion = FloorModel | SubBuildingModel;

export type BuildingModel = {
  __typename?: 'BuildingModel';
  children: Array<BuildingHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  division_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type BuildingRequestInput = {
  deletBeforeSync: Scalars['Boolean']['input'];
  floors?: InputMaybe<Array<FloorRequestInput>>;
  id: Scalars['ID']['input'];
};

export type BuildingUpdateDto = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type BuildingsResolver_BuildingFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type BuildingsResolver_Building_FilterInputType = {
  and?: InputMaybe<Array<BuildingsResolver_BuildingFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BuildingsResolver_BuildingFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type BuildingsResolver_BuildingsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type BuildingsResolver_Buildings_FilterInputType = {
  and?: InputMaybe<Array<BuildingsResolver_BuildingsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<BuildingsResolver_BuildingsFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type BuildingsResolver_Buildings_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  division_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  region_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type BulkOperationError = {
  __typename?: 'BulkOperationError';
  entity?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['JSONObject']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  masterEntity?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
};

export type CiscoFloorDto = {
  /** Floor Location Id */
  FloorLocId: Scalars['String']['input'];
  /** Floor Name */
  FloorName: Scalars['String']['input'];
};

export type CiscoFloorModel = {
  __typename?: 'CiscoFloorModel';
  /** Floor Location Id */
  FloorLocId: Scalars['String']['output'];
  /** Floor Name */
  FloorName: Scalars['String']['output'];
};

export type CurrentUserModel = {
  __typename?: 'CurrentUserModel';
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['JSONObject']['output']>;
};

export type CustomerHierarchyUnion = DivisionModel | RegionModel | SiteModel;

export type CustomerModel = {
  __typename?: 'CustomerModel';
  alias_name: Scalars['String']['output'];
  auth_connection_name?: Maybe<Scalars['String']['output']>;
  auth_integration_client_id: Scalars['String']['output'];
  auth_org_id?: Maybe<Scalars['String']['output']>;
  auto_logout_seconds: Scalars['Float']['output'];
  children: Array<CustomerHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc: Scalars['DateTime']['output'];
  crm_account_id?: Maybe<Scalars['String']['output']>;
  crm_site_id?: Maybe<Scalars['String']['output']>;
  data_warehouse_configuration?: Maybe<Scalars['JSONObject']['output']>;
  default_timezone: Scalars['String']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  email_service_configuration?: Maybe<Scalars['JSONObject']['output']>;
  enrollment_message?: Maybe<Scalars['String']['output']>;
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_ad_enabled: Scalars['Boolean']['output'];
  is_blocked: Scalars['Boolean']['output'];
  license_info?: Maybe<Scalars['JSONObject']['output']>;
  locale: LocaleModel;
  locale_id: Scalars['Int']['output'];
  pulse_site_id?: Maybe<Scalars['String']['output']>;
  subdomain: Scalars['String']['output'];
  theme?: Maybe<Scalars['JSONObject']['output']>;
  twilio_account_sid?: Maybe<Scalars['String']['output']>;
  twilio_area_code?: Maybe<Scalars['String']['output']>;
  twilio_auth_token?: Maybe<Scalars['String']['output']>;
  twilio_messaging_service_id?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerPublicModel = {
  __typename?: 'CustomerPublicModel';
  auth_connection_name?: Maybe<Scalars['String']['output']>;
  auth_org_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locale_id: Scalars['Int']['output'];
};

export type CustomerSiteCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  default_timezone: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CustomerUpdateDto = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  auto_logout_seconds?: InputMaybe<Scalars['Float']['input']>;
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  data_warehouse_configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  default_timezone?: InputMaybe<Scalars['String']['input']>;
  email_service_configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  enrollment_message?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  is_ad_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  license_info?: InputMaybe<Scalars['JSONObject']['input']>;
  locale_id?: InputMaybe<Scalars['Int']['input']>;
  pulse_site_id?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['JSONObject']['input']>;
  twilio_account_sid?: InputMaybe<Scalars['String']['input']>;
  twilio_area_code?: InputMaybe<Scalars['String']['input']>;
  twilio_auth_token?: InputMaybe<Scalars['String']['input']>;
  twilio_messaging_service_id?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersResolver_CustomersFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  auth_connection_name?: InputMaybe<String_PropertyFilterInputType>;
  auth_integration_client_id?: InputMaybe<String_PropertyFilterInputType>;
  auth_org_id?: InputMaybe<String_PropertyFilterInputType>;
  auto_logout_seconds?: InputMaybe<Number_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  data_warehouse_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email_service_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  enrollment_message?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_ad_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_blocked?: InputMaybe<Boolean_PropertyFilterInputType>;
  license_info?: InputMaybe<JsonObject_PropertyFilterInputType>;
  locale_id?: InputMaybe<Int_PropertyFilterInputType>;
  pulse_site_id?: InputMaybe<String_PropertyFilterInputType>;
  subdomain?: InputMaybe<String_PropertyFilterInputType>;
  theme?: InputMaybe<JsonObject_PropertyFilterInputType>;
  twilio_account_sid?: InputMaybe<String_PropertyFilterInputType>;
  twilio_area_code?: InputMaybe<String_PropertyFilterInputType>;
  twilio_auth_token?: InputMaybe<String_PropertyFilterInputType>;
  twilio_messaging_service_id?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type CustomersResolver_Customers_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<CustomersResolver_CustomersFilterInputType>>;
  auth_connection_name?: InputMaybe<String_PropertyFilterInputType>;
  auth_integration_client_id?: InputMaybe<String_PropertyFilterInputType>;
  auth_org_id?: InputMaybe<String_PropertyFilterInputType>;
  auto_logout_seconds?: InputMaybe<Number_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  data_warehouse_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email_service_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  enrollment_message?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_ad_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_blocked?: InputMaybe<Boolean_PropertyFilterInputType>;
  license_info?: InputMaybe<JsonObject_PropertyFilterInputType>;
  locale_id?: InputMaybe<Int_PropertyFilterInputType>;
  or?: InputMaybe<Array<CustomersResolver_CustomersFilterInputType>>;
  pulse_site_id?: InputMaybe<String_PropertyFilterInputType>;
  subdomain?: InputMaybe<String_PropertyFilterInputType>;
  theme?: InputMaybe<JsonObject_PropertyFilterInputType>;
  twilio_account_sid?: InputMaybe<String_PropertyFilterInputType>;
  twilio_area_code?: InputMaybe<String_PropertyFilterInputType>;
  twilio_auth_token?: InputMaybe<String_PropertyFilterInputType>;
  twilio_messaging_service_id?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type CustomersResolver_Customers_SortingInputType = {
  alias_name?: InputMaybe<SortType>;
  auth_connection_name?: InputMaybe<SortType>;
  auth_integration_client_id?: InputMaybe<SortType>;
  auth_org_id?: InputMaybe<SortType>;
  auto_logout_seconds?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  crm_account_id?: InputMaybe<SortType>;
  crm_site_id?: InputMaybe<SortType>;
  data_warehouse_configuration?: InputMaybe<SortType>;
  default_timezone?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  email_service_configuration?: InputMaybe<SortType>;
  enrollment_message?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_ad_enabled?: InputMaybe<SortType>;
  is_blocked?: InputMaybe<SortType>;
  license_info?: InputMaybe<SortType>;
  locale_id?: InputMaybe<SortType>;
  pulse_site_id?: InputMaybe<SortType>;
  subdomain?: InputMaybe<SortType>;
  theme?: InputMaybe<SortType>;
  twilio_account_sid?: InputMaybe<SortType>;
  twilio_area_code?: InputMaybe<SortType>;
  twilio_auth_token?: InputMaybe<SortType>;
  twilio_messaging_service_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type DateTime_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notbetween?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DepartmentCreateDto = {
  announcement_text?: InputMaybe<Scalars['String']['input']>;
  appointment_confirmation_message?: InputMaybe<Scalars['String']['input']>;
  care_table_configuration?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operating_hours?: InputMaybe<Scalars['JSON']['input']>;
  site_id: Scalars['Int']['input'];
  waiting_table_configuration?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DepartmentLocationMapCreateDto = {
  department_id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};

export type DepartmentLocationMapModel = {
  __typename?: 'DepartmentLocationMapModel';
  created_by: Scalars['String']['output'];
  created_utc: Scalars['DateTime']['output'];
  customer_id: Scalars['Int']['output'];
  department_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
};

export type DepartmentLocationMapRemoveDto = {
  department_id: Scalars['Int']['input'];
  location_id: Scalars['Int']['input'];
};

export type DepartmentLocationMapRemoveModel = {
  __typename?: 'DepartmentLocationMapRemoveModel';
  customer_id: Scalars['Int']['output'];
  department_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
};

export type DepartmentModel = {
  __typename?: 'DepartmentModel';
  announcement_text?: Maybe<Scalars['String']['output']>;
  appointment_confirmation_message?: Maybe<Scalars['String']['output']>;
  auto_checkout_configuration?: Maybe<Scalars['JSONObject']['output']>;
  care_table_configuration: Array<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  department_shifts?: Maybe<Array<DepartmentShiftModel>>;
  id: Scalars['Int']['output'];
  locations?: Maybe<Array<LocationModel>>;
  name: Scalars['String']['output'];
  operating_hours?: Maybe<Scalars['JSON']['output']>;
  site: SiteModel;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
  waiting_table_configuration: Array<Scalars['String']['output']>;
};

export type DepartmentShiftCreateDto = {
  department_id: Scalars['Int']['input'];
  end_time: Scalars['String']['input'];
  is_enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
};

export type DepartmentShiftModel = {
  __typename?: 'DepartmentShiftModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  department: DepartmentModel;
  department_id: Scalars['Int']['output'];
  end_time: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  start_time: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type DepartmentShiftUpdateDto = {
  department_id: Scalars['Int']['input'];
  end_time: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_time: Scalars['String']['input'];
};

export type DepartmentShiftsResolver_DepartmentShiftFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_time?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  start_time?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DepartmentShiftsResolver_DepartmentShift_FilterInputType = {
  and?: InputMaybe<Array<DepartmentShiftsResolver_DepartmentShiftFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_time?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DepartmentShiftsResolver_DepartmentShiftFilterInputType>>;
  start_time?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DepartmentShiftsResolver_DepartmentShiftsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_time?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  start_time?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DepartmentShiftsResolver_DepartmentShifts_FilterInputType = {
  and?: InputMaybe<Array<DepartmentShiftsResolver_DepartmentShiftsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  end_time?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_enabled?: InputMaybe<Boolean_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DepartmentShiftsResolver_DepartmentShiftsFilterInputType>>;
  start_time?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DepartmentShiftsResolver_DepartmentShifts_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  department_id?: InputMaybe<SortType>;
  end_time?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_enabled?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  start_time?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type DepartmentUpdateDto = {
  announcement_text?: InputMaybe<Scalars['String']['input']>;
  appointment_confirmation_message?: InputMaybe<Scalars['String']['input']>;
  auto_checkout_configuration?: InputMaybe<Scalars['JSONObject']['input']>;
  care_table_configuration?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  operating_hours?: InputMaybe<Scalars['JSON']['input']>;
  waiting_table_configuration?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DepartmentsResolver_DepartmentFilterInputType = {
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_Department_FilterInputType = {
  and?: InputMaybe<Array<DepartmentsResolver_DepartmentFilterInputType>>;
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  or?: InputMaybe<Array<DepartmentsResolver_DepartmentFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_DepartmentsCountFilterInputType = {
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_DepartmentsCount_FilterInputType = {
  and?: InputMaybe<Array<DepartmentsResolver_DepartmentsCountFilterInputType>>;
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  or?: InputMaybe<Array<DepartmentsResolver_DepartmentsCountFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_DepartmentsFilterInputType = {
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_Departments_FilterInputType = {
  and?: InputMaybe<Array<DepartmentsResolver_DepartmentsFilterInputType>>;
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  or?: InputMaybe<Array<DepartmentsResolver_DepartmentsFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type DepartmentsResolver_Departments_SortingInputType = {
  announcement_text?: InputMaybe<SortType>;
  appointment_confirmation_message?: InputMaybe<SortType>;
  auto_checkout_configuration?: InputMaybe<SortType>;
  care_table_configuration?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  operating_hours?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
  waiting_table_configuration?: InputMaybe<SortType>;
};

export type DeviceCreateDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  site: SiteModel;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceUpdateDto = {
  email: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type DevicesResolver_DeviceFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_Device_FilterInputType = {
  and?: InputMaybe<Array<DevicesResolver_DeviceFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DevicesResolver_DeviceFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_DevicesCountFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_DevicesCount_FilterInputType = {
  and?: InputMaybe<Array<DevicesResolver_DevicesCountFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DevicesResolver_DevicesCountFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_DevicesFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_Devices_FilterInputType = {
  and?: InputMaybe<Array<DevicesResolver_DevicesFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DevicesResolver_DevicesFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DevicesResolver_Devices_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  email?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type DisplayBoardsCountByType = {
  __typename?: 'DisplayBoardsCountByType';
  count: Scalars['Float']['output'];
  customer_id: Scalars['Float']['output'];
  department_id: Scalars['Float']['output'];
  display_board_type_id: Scalars['Float']['output'];
};

export type DivisionChangeParentDto = {
  id: Scalars['Int']['input'];
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DivisionCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DivisionHierarchyUnion = SiteModel;

export type DivisionModel = {
  __typename?: 'DivisionModel';
  children: Array<DivisionHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  crm_account_id?: Maybe<Scalars['String']['output']>;
  crm_site_id?: Maybe<Scalars['String']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<RegionModel>;
  region_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type DivisionSiteCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  default_timezone: Scalars['String']['input'];
  division_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type DivisionUpdateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type DivisionsResolver_DivisionFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DivisionsResolver_Division_FilterInputType = {
  and?: InputMaybe<Array<DivisionsResolver_DivisionFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DivisionsResolver_DivisionFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DivisionsResolver_DivisionsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DivisionsResolver_Divisions_FilterInputType = {
  and?: InputMaybe<Array<DivisionsResolver_DivisionsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<DivisionsResolver_DivisionsFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type DivisionsResolver_Divisions_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  crm_account_id?: InputMaybe<SortType>;
  crm_site_id?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  region_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type Filters = {
  __typename?: 'Filters';
  batteryStatus?: Maybe<Array<Scalars['String']['output']>>;
  deviceTypes?: Maybe<Array<Scalars['String']['output']>>;
  versions?: Maybe<Array<Scalars['String']['output']>>;
};

export type FloorChangeParentToBuildingDto = {
  building_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type FloorChangeParentToSiteDto = {
  id: Scalars['Int']['input'];
};

export type FloorChangeParentToSubBuildingDto = {
  id: Scalars['Int']['input'];
  sub_building_id: Scalars['Int']['input'];
};

export type FloorModel = {
  __typename?: 'FloorModel';
  building?: Maybe<BuildingModel>;
  building_id?: Maybe<Scalars['Int']['output']>;
  change_parent_utc?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  division_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
  site_id: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  subBuilding?: Maybe<SubBuildingModel>;
  sub_building_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type FloorRequestInput = {
  deletBeforeSync: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  zones?: InputMaybe<Array<ZoneRequestInput>>;
};

export type FloorSetSortOrderDto = {
  floors: Array<FloorSortOrder>;
};

export type FloorSortOrder = {
  id: Scalars['Int']['input'];
  sort_order: Scalars['Int']['input'];
};

export type FloorSortOrderModel = {
  __typename?: 'FloorSortOrderModel';
  floors: Array<Scalars['Int']['output']>;
};

export type FloorUpdateDto = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type FloorsResolver_FloorFilterInputType = {
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  change_parent_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  sort_order?: InputMaybe<Int_PropertyFilterInputType>;
  sub_building_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type FloorsResolver_Floor_FilterInputType = {
  and?: InputMaybe<Array<FloorsResolver_FloorFilterInputType>>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  change_parent_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<FloorsResolver_FloorFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  sort_order?: InputMaybe<Int_PropertyFilterInputType>;
  sub_building_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type FloorsResolver_FloorsFilterInputType = {
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  change_parent_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  sort_order?: InputMaybe<Int_PropertyFilterInputType>;
  sub_building_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type FloorsResolver_Floors_FilterInputType = {
  and?: InputMaybe<Array<FloorsResolver_FloorsFilterInputType>>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  change_parent_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<FloorsResolver_FloorsFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  sort_order?: InputMaybe<Int_PropertyFilterInputType>;
  sub_building_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type FloorsResolver_Floors_SortingInputType = {
  building_id?: InputMaybe<SortType>;
  change_parent_utc?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  division_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  region_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  sort_order?: InputMaybe<SortType>;
  sub_building_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type GetHierarchyResponse = {
  __typename?: 'GetHierarchyResponse';
  site?: Maybe<Array<PolestarSite>>;
};

export type GetInfraRequestInput = {
  siteId: Array<Scalars['String']['input']>;
};

export type HhLocationTypeModel = {
  __typename?: 'HHLocationTypeModel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HhLocationTypesResolver_HhLocationTypeFilterInputType = {
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type HhLocationTypesResolver_HhLocationType_FilterInputType = {
  and?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypeFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypeFilterInputType>>;
};

export type HhLocationTypesResolver_HhLocationTypesCountFilterInputType = {
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type HhLocationTypesResolver_HhLocationTypesCount_FilterInputType = {
  and?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypesCountFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypesCountFilterInputType>>;
};

export type HhLocationTypesResolver_HhLocationTypesFilterInputType = {
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type HhLocationTypesResolver_HhLocationTypes_FilterInputType = {
  and?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypesFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypesFilterInputType>>;
};

export type HhLocationTypesResolver_HhLocationTypes_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type InfraSyncStatus = {
  __typename?: 'InfraSyncStatus';
  lastSyncOn: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  statusCode?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type InfrastructurePolestarResolver_PolestarInfrastructuresFilterInputType = {
  batteryStatus?: InputMaybe<String_PropertyFilterInputType>;
  clientId?: InputMaybe<Int_PropertyFilterInputType>;
  deviceCode?: InputMaybe<String_PropertyFilterInputType>;
  deviceId?: InputMaybe<String_PropertyFilterInputType>;
  deviceType?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  manufactureName?: InputMaybe<String_PropertyFilterInputType>;
  version?: InputMaybe<String_PropertyFilterInputType>;
};

export type InfrastructurePolestarResolver_PolestarInfrastructuresView_SortingInputType = {
  batteryStatus?: InputMaybe<SortType>;
  clientId?: InputMaybe<SortType>;
  deviceCode?: InputMaybe<SortType>;
  deviceId?: InputMaybe<SortType>;
  deviceType?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  manufactureName?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type InfrastructurePolestarResolver_PolestarInfrastructures_FilterInputType = {
  and?: InputMaybe<Array<InfrastructurePolestarResolver_PolestarInfrastructuresFilterInputType>>;
  batteryStatus?: InputMaybe<String_PropertyFilterInputType>;
  clientId?: InputMaybe<Int_PropertyFilterInputType>;
  deviceCode?: InputMaybe<String_PropertyFilterInputType>;
  deviceId?: InputMaybe<String_PropertyFilterInputType>;
  deviceType?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  manufactureName?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<InfrastructurePolestarResolver_PolestarInfrastructuresFilterInputType>>;
  version?: InputMaybe<String_PropertyFilterInputType>;
};

export type InfrastructurePolestarResolver_PolestarInfrastructures_SortingInputType = {
  batteryStatus?: InputMaybe<SortType>;
  clientId?: InputMaybe<SortType>;
  deviceCode?: InputMaybe<SortType>;
  deviceId?: InputMaybe<SortType>;
  deviceType?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  manufactureName?: InputMaybe<SortType>;
  version?: InputMaybe<SortType>;
};

export type Int_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Int']['input']>>;
  notin?: InputMaybe<Array<Scalars['Int']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationConfigModel = {
  __typename?: 'IntegrationConfigModel';
  certificateFingerprint: Scalars['String']['output'];
  mqttUrl: Scalars['String']['output'];
  restApiKey: Scalars['String']['output'];
  restApiUrl: Scalars['String']['output'];
};

export type IntegrationModel = {
  __typename?: 'IntegrationModel';
  certificate_fingerprint?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mqtt_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  protected: Scalars['Boolean']['output'];
  rest_api_key?: Maybe<Scalars['String']['output']>;
  rest_api_url?: Maybe<Scalars['String']['output']>;
  sub_domain: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationViewModel = {
  __typename?: 'IntegrationViewModel';
  count: Scalars['Int']['output'];
  nodes: Array<IntegrationModel>;
};

export type IntegrationsResolver_IntegrationFilterInputType = {
  certificate_fingerprint?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  mqtt_url?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  protected?: InputMaybe<Boolean_PropertyFilterInputType>;
  rest_api_key?: InputMaybe<String_PropertyFilterInputType>;
  rest_api_url?: InputMaybe<String_PropertyFilterInputType>;
  sub_domain?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type IntegrationsResolver_Integration_FilterInputType = {
  and?: InputMaybe<Array<IntegrationsResolver_IntegrationFilterInputType>>;
  certificate_fingerprint?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  mqtt_url?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IntegrationsResolver_IntegrationFilterInputType>>;
  protected?: InputMaybe<Boolean_PropertyFilterInputType>;
  rest_api_key?: InputMaybe<String_PropertyFilterInputType>;
  rest_api_url?: InputMaybe<String_PropertyFilterInputType>;
  sub_domain?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type IntegrationsResolver_IntegrationsViewFilterInputType = {
  certificate_fingerprint?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  mqtt_url?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  protected?: InputMaybe<Boolean_PropertyFilterInputType>;
  rest_api_key?: InputMaybe<String_PropertyFilterInputType>;
  rest_api_url?: InputMaybe<String_PropertyFilterInputType>;
  sub_domain?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type IntegrationsResolver_IntegrationsView_FilterInputType = {
  and?: InputMaybe<Array<IntegrationsResolver_IntegrationsViewFilterInputType>>;
  certificate_fingerprint?: InputMaybe<String_PropertyFilterInputType>;
  description?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  mqtt_url?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<IntegrationsResolver_IntegrationsViewFilterInputType>>;
  protected?: InputMaybe<Boolean_PropertyFilterInputType>;
  rest_api_key?: InputMaybe<String_PropertyFilterInputType>;
  rest_api_url?: InputMaybe<String_PropertyFilterInputType>;
  sub_domain?: InputMaybe<String_PropertyFilterInputType>;
  type?: InputMaybe<String_PropertyFilterInputType>;
};

export type IntegrationsResolver_IntegrationsView_SortingInputType = {
  certificate_fingerprint?: InputMaybe<SortType>;
  description?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  mqtt_url?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  protected?: InputMaybe<SortType>;
  rest_api_key?: InputMaybe<SortType>;
  rest_api_url?: InputMaybe<SortType>;
  sub_domain?: InputMaybe<SortType>;
  type?: InputMaybe<SortType>;
};

export type JsonObject_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  eq?: InputMaybe<Scalars['JSONObject']['input']>;
  gt?: InputMaybe<Scalars['JSONObject']['input']>;
  gte?: InputMaybe<Scalars['JSONObject']['input']>;
  in?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['JSONObject']['input']>;
  lte?: InputMaybe<Scalars['JSONObject']['input']>;
  neq?: InputMaybe<Scalars['JSONObject']['input']>;
  notbetween?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  notin?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Json_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['JSON']['input']>>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
  notbetween?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notin?: InputMaybe<Array<Scalars['JSON']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocaleModel = {
  __typename?: 'LocaleModel';
  display_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
};

export type LocalesResolver_Locales_SortingInputType = {
  display_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  locale?: InputMaybe<SortType>;
};

export type LocationBulkDto = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  asset_location_type_id: Scalars['Int']['input'];
  department_ids?: InputMaybe<Scalars['String']['input']>;
  floor_id?: InputMaybe<Scalars['Int']['input']>;
  hh_location_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_non_reporting?: InputMaybe<Scalars['Boolean']['input']>;
  location_group_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type LocationCreateDto = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  asset_location_type_id: Scalars['Int']['input'];
  boundary?: InputMaybe<Scalars['JSONObject']['input']>;
  department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  floor_id?: InputMaybe<Scalars['Int']['input']>;
  hh_location_type_id?: InputMaybe<Scalars['Int']['input']>;
  is_non_reporting?: InputMaybe<Scalars['Boolean']['input']>;
  is_zone: Scalars['Boolean']['input'];
  location_group_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shape_id?: InputMaybe<Scalars['String']['input']>;
  site_id: Scalars['Int']['input'];
};

export type LocationGroupCreateDto = {
  location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  parent_group_id?: InputMaybe<Scalars['Int']['input']>;
  site_id: Scalars['Int']['input'];
};

export type LocationGroupModel = {
  __typename?: 'LocationGroupModel';
  children_groups_count?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  locations: Array<LocationModel>;
  name: Scalars['String']['output'];
  parent_group_id?: Maybe<Scalars['Int']['output']>;
  parent_location_group?: Maybe<LocationGroupModel>;
  site: SiteModel;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationGroupOrderBy = {
  name?: InputMaybe<OrderBy>;
};

export type LocationGroupUpdateDto = {
  id: Scalars['Int']['input'];
  location_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  parent_group_id?: InputMaybe<Scalars['Int']['input']>;
  site_id: Scalars['Int']['input'];
};

export type LocationGroupsResolver_LocationGroupFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationGroupsResolver_LocationGroup_FilterInputType = {
  and?: InputMaybe<Array<LocationGroupsResolver_LocationGroupFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationGroupsResolver_LocationGroupFilterInputType>>;
  parent_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationGroupsResolver_LocationGroupsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationGroupsResolver_LocationGroups_FilterInputType = {
  and?: InputMaybe<Array<LocationGroupsResolver_LocationGroupsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationGroupsResolver_LocationGroupsFilterInputType>>;
  parent_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationGroupsResolver_LocationGroups_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_group_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type LocationModel = {
  __typename?: 'LocationModel';
  alias_name?: Maybe<Scalars['String']['output']>;
  asset_location_type_id: Scalars['Int']['output'];
  boundary?: Maybe<Scalars['JSONObject']['output']>;
  building_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  department_ids?: Maybe<Array<Scalars['Int']['output']>>;
  department_names?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Array<DepartmentModel>>;
  floor_id?: Maybe<Scalars['Int']['output']>;
  hhLocationType?: Maybe<LocationTypeModel>;
  hh_location_type_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_non_reporting?: Maybe<Scalars['Boolean']['output']>;
  is_zone: Scalars['Boolean']['output'];
  locationGroup?: Maybe<LocationGroupModel>;
  locationType: LocationTypeModel;
  location_group_id?: Maybe<Scalars['Int']['output']>;
  location_type_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent_name?: Maybe<Scalars['String']['output']>;
  sensors_ids?: Maybe<Scalars['String']['output']>;
  shape_id?: Maybe<Scalars['String']['output']>;
  site: SiteModel;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationOrderBy = {
  alias_name?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

export type LocationTypeModel = {
  __typename?: 'LocationTypeModel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LocationTypesResolver_LocationTypesFilterInputType = {
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type LocationTypesResolver_LocationTypes_FilterInputType = {
  and?: InputMaybe<Array<LocationTypesResolver_LocationTypesFilterInputType>>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationTypesResolver_LocationTypesFilterInputType>>;
};

export type LocationTypesResolver_LocationTypes_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type LocationUpdateDto = {
  alias_name?: InputMaybe<Scalars['String']['input']>;
  asset_location_type_id: Scalars['Int']['input'];
  boundary?: InputMaybe<Scalars['JSONObject']['input']>;
  department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  floor_id?: InputMaybe<Scalars['Int']['input']>;
  hh_location_type_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  is_non_reporting?: InputMaybe<Scalars['Boolean']['input']>;
  is_zone: Scalars['Boolean']['input'];
  location_group_id?: InputMaybe<Scalars['Int']['input']>;
  location_type_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shape_id?: InputMaybe<Scalars['String']['input']>;
};

export type LocationsResolver_AvailablePickupStations_SortingInputType = {
  alias_name?: InputMaybe<SortType>;
  asset_location_type_id?: InputMaybe<SortType>;
  boundary?: InputMaybe<SortType>;
  building_id?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  department_ids?: InputMaybe<SortType>;
  department_names?: InputMaybe<SortType>;
  floor_id?: InputMaybe<SortType>;
  hh_location_type_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_non_reporting?: InputMaybe<SortType>;
  is_zone?: InputMaybe<SortType>;
  location_group_id?: InputMaybe<SortType>;
  location_type_id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_name?: InputMaybe<SortType>;
  sensors_ids?: InputMaybe<SortType>;
  shape_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type LocationsResolver_LocationFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationsResolver_Location_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<LocationsResolver_LocationFilterInputType>>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationsResolver_LocationFilterInputType>>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsCountFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsCount_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<LocationsResolver_LocationsCountFilterInputType>>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationsResolver_LocationsCountFilterInputType>>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_name?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsPageFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsPage_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<LocationsResolver_LocationsPageFilterInputType>>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationsResolver_LocationsPageFilterInputType>>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type LocationsResolver_LocationsPage_SortingInputType = {
  alias_name?: InputMaybe<SortType>;
  asset_location_type_id?: InputMaybe<SortType>;
  boundary?: InputMaybe<SortType>;
  building_id?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  department_ids?: InputMaybe<SortType>;
  department_names?: InputMaybe<SortType>;
  floor_id?: InputMaybe<SortType>;
  hh_location_type_id?: InputMaybe<SortType>;
  hh_location_type_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_non_reporting?: InputMaybe<SortType>;
  is_zone?: InputMaybe<SortType>;
  location_group_id?: InputMaybe<SortType>;
  location_type_id?: InputMaybe<SortType>;
  location_type_name?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_name?: InputMaybe<SortType>;
  sensors_ids?: InputMaybe<SortType>;
  shape_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type LocationsResolver_Locations_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<LocationsResolver_LocationsFilterInputType>>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_id?: InputMaybe<Number_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_name?: InputMaybe<Number_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<LocationsResolver_LocationsFilterInputType>>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type LocationsResolver_Locations_SortingInputType = {
  alias_name?: InputMaybe<SortType>;
  asset_location_type_id?: InputMaybe<SortType>;
  boundary?: InputMaybe<SortType>;
  building_id?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  department_ids?: InputMaybe<SortType>;
  department_names?: InputMaybe<SortType>;
  floor_id?: InputMaybe<SortType>;
  hh_location_type_id?: InputMaybe<SortType>;
  hh_location_type_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_non_reporting?: InputMaybe<SortType>;
  is_zone?: InputMaybe<SortType>;
  location_group_id?: InputMaybe<SortType>;
  location_type_id?: InputMaybe<SortType>;
  location_type_name?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_name?: InputMaybe<SortType>;
  sensors_ids?: InputMaybe<SortType>;
  shape_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Assign department to a staff */
  addStaffDepartment: StaffModel;
  /** Create a new building */
  createBuilding: BuildingModel;
  /** Create a new floor */
  createBuildingFloor: FloorModel;
  /** Create a new department */
  createDepartment: DepartmentModel;
  /** Create a new department-location-map record */
  createDepartmentLocationMap: DepartmentLocationMapModel;
  /** Create a department shift */
  createDepartmentShift: DepartmentShiftModel;
  /** Create a new device */
  createDevice: DeviceModel;
  /** Create a new division */
  createDivision: DivisionModel;
  /** Create a new site */
  createDivisionSite: SiteModel;
  /** Create a new floor */
  createFloor: FloorModel;
  /** Create a new location */
  createLocation: LocationModel;
  /** Create a new Location Group */
  createLocationGroup: LocationGroupModel;
  /** Create a new region */
  createRegion: RegionModel;
  /** Create a new division */
  createRegionDivision: DivisionModel;
  /** Create a new site */
  createRegionSite: SiteModel;
  /** Create a new sensor */
  createSensor: SensorModel;
  /** Create a new site */
  createSite: SiteModel;
  /** Create a new staff */
  createStaff: StaffModel;
  /** Create a new sub-building */
  createSubBuilding: SubBuildingModel;
  /** Create a new floor */
  createSubBuildingFloor: FloorModel;
  /** Create a new tag */
  createTag: TagModel;
  /** Create a new user */
  createUser: Scalars['String']['output'];
  /** Create a new user-notification */
  createUserNotification: UserNotificationModel;
  createWorkflowDepartment: WorkflowDepartmentModel;
  createWorkflowDepartmentBulk: Array<WorkflowDepartmentModel>;
  /** Change parent of a division */
  divisionChangeParent: DivisionModel;
  /** Change floor parent to a building */
  floorChangeParentToBuilding: FloorModel;
  /** Change floor parent to a site */
  floorChangeParentToSite: FloorModel;
  /** Change floor parent to a sub-building */
  floorChangeParentToSubBuilding: FloorModel;
  /** Change floors sort order */
  floorsSetSortOrder: FloorSortOrderModel;
  /** Bulk operation for locations */
  locationsBulk: Array<BulkOperationError>;
  /** Remove a building */
  removeBuilding: RemoveModel;
  /** Remove a department */
  removeDepartment: RemoveModel;
  /** Remove a department-location-map record */
  removeDepartmentLocationMap: DepartmentLocationMapRemoveModel;
  /** Remove a department shift */
  removeDepartmentShift: RemoveModel;
  /** Remove a device */
  removeDevice: RemoveModel;
  /** Remove a division */
  removeDivision: RemoveModel;
  /** Remove a floor */
  removeFloor: RemoveModel;
  /** Remove a location */
  removeLocation: RemoveModel;
  /** Remove a Location Group */
  removeLocationGroup: RemoveModel;
  /** Remove a region */
  removeRegion: RemoveModel;
  /** Remove a sensor */
  removeSensor: RemoveModel;
  /** Remove a site */
  removeSite: RemoveModel;
  /** Remove a staff */
  removeStaff: RemoveModel;
  /** Remove department from a staff */
  removeStaffDepartment: StaffModel;
  /** Remove a sub-building */
  removeSubBuilding: RemoveModel;
  /** Remove a tag */
  removeTag: RemoveModel;
  /** Remove a user */
  removeUser: Scalars['String']['output'];
  /** Remove a workflow department */
  removeWorkflowDepartment: RemoveModel;
  /** Reset a user password */
  resetPassword: Scalars['String']['output'];
  /** Bulk operation for sensors */
  sensorsBulk: Array<SensorBulkOperationError>;
  /** Change parent of a site to customer */
  siteChangeParentToCustomer: SiteModel;
  /** Change parent of a site to division */
  siteChangeParentToDivision: SiteModel;
  /** Change parent of a site to region */
  siteChangeParentToRegion: SiteModel;
  /** Bulk operation for staff */
  staffBulk: Array<StaffBulkOperationError>;
  /** Change parent of a sub-building */
  subBuildingChangeParent: SubBuildingModel;
  syncPolestarInfra: SyncInfraResponse;
  /** Sync hierarchy entity */
  syncPolestarInfrastructure: SyncHierarchyResponse;
  /** Update a building */
  updateBuilding: BuildingModel;
  /** Update a customer */
  updateCustomer: CustomerModel;
  /** Update a department */
  updateDepartment: DepartmentModel;
  /** Update a department shift */
  updateDepartmentShift: DepartmentShiftModel;
  /** Update a device */
  updateDevice: DeviceModel;
  /** Update a division */
  updateDivision: DivisionModel;
  /** Update a floor */
  updateFloor: FloorModel;
  /** Update a location */
  updateLocation: LocationModel;
  /** Update a Location Group */
  updateLocationGroup: LocationGroupModel;
  /** Update user preferences */
  updatePreferences: Scalars['JSON']['output'];
  /** Update a region */
  updateRegion: RegionModel;
  /** Update a division */
  updateRegionDivision: DivisionModel;
  /** Update a sensor */
  updateSensor: SensorModel;
  /** Update/create coordinates for a single sensor device.  */
  updateSensorCoordinates: SensorCoordModel;
  /** Update a site */
  updateSite: SiteModel;
  /** Update a staff */
  updateStaff: StaffModel;
  /** Update staff type */
  updateStaffType: StaffModel;
  /** Update a sub-building */
  updateSubBuilding: SubBuildingModel;
  /** Update a tag */
  updateTag: TagModel;
  /** Update a user */
  updateUser: Scalars['String']['output'];
  /** Update a user-notification */
  updateUserNotification: UserNotificationModel;
  /** Bulk operation for users */
  usersBulk: Array<UserBulkOperationError>;
};


export type MutationAddStaffDepartmentArgs = {
  department_id: Scalars['Int']['input'];
  staff_id: Scalars['Int']['input'];
};


export type MutationCreateBuildingArgs = {
  building: BuildingCreateDto;
};


export type MutationCreateBuildingFloorArgs = {
  floor: BuildingFloorCreateDto;
};


export type MutationCreateDepartmentArgs = {
  department: DepartmentCreateDto;
};


export type MutationCreateDepartmentLocationMapArgs = {
  department_location: DepartmentLocationMapCreateDto;
};


export type MutationCreateDepartmentShiftArgs = {
  departmentShift: DepartmentShiftCreateDto;
};


export type MutationCreateDeviceArgs = {
  device: DeviceCreateDto;
};


export type MutationCreateDivisionArgs = {
  division: DivisionCreateDto;
};


export type MutationCreateDivisionSiteArgs = {
  site: DivisionSiteCreateDto;
};


export type MutationCreateFloorArgs = {
  floor: SiteFloorCreateDto;
};


export type MutationCreateLocationArgs = {
  location: LocationCreateDto;
};


export type MutationCreateLocationGroupArgs = {
  location_group: LocationGroupCreateDto;
};


export type MutationCreateRegionArgs = {
  region: RegionCreateDto;
};


export type MutationCreateRegionDivisionArgs = {
  division: RegionDivisionCreateDto;
};


export type MutationCreateRegionSiteArgs = {
  site: RegionSiteCreateDto;
};


export type MutationCreateSensorArgs = {
  sensor: SensorCreateDto;
};


export type MutationCreateSiteArgs = {
  site: CustomerSiteCreateDto;
};


export type MutationCreateStaffArgs = {
  staff: StaffCreateDto;
};


export type MutationCreateSubBuildingArgs = {
  sub_building: SubBuildingCreateDto;
};


export type MutationCreateSubBuildingFloorArgs = {
  floor: SubBuildingFloorCreateDto;
};


export type MutationCreateTagArgs = {
  tag: TagCreateDto;
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  roles?: InputMaybe<Array<RoleId>>;
};


export type MutationCreateUserNotificationArgs = {
  user_notification: UserNotificationCreateDto;
};


export type MutationCreateWorkflowDepartmentArgs = {
  workflow_department: WorkflowDepartmentCreateDto;
};


export type MutationCreateWorkflowDepartmentBulkArgs = {
  workflow_departments: Array<WorkflowDepartmentCreateDto>;
};


export type MutationDivisionChangeParentArgs = {
  division: DivisionChangeParentDto;
};


export type MutationFloorChangeParentToBuildingArgs = {
  floor: FloorChangeParentToBuildingDto;
};


export type MutationFloorChangeParentToSiteArgs = {
  floor: FloorChangeParentToSiteDto;
};


export type MutationFloorChangeParentToSubBuildingArgs = {
  floor: FloorChangeParentToSubBuildingDto;
};


export type MutationFloorsSetSortOrderArgs = {
  payload: FloorSetSortOrderDto;
};


export type MutationLocationsBulkArgs = {
  locations: Array<LocationBulkDto>;
  site_id: Scalars['Int']['input'];
};


export type MutationRemoveBuildingArgs = {
  building: RemoveDto;
};


export type MutationRemoveDepartmentArgs = {
  department: RemoveDto;
};


export type MutationRemoveDepartmentLocationMapArgs = {
  department_location: DepartmentLocationMapRemoveDto;
};


export type MutationRemoveDepartmentShiftArgs = {
  departmentShift: RemoveDto;
};


export type MutationRemoveDeviceArgs = {
  device: RemoveDto;
};


export type MutationRemoveDivisionArgs = {
  division: RemoveDto;
};


export type MutationRemoveFloorArgs = {
  floor: RemoveDto;
};


export type MutationRemoveLocationArgs = {
  location: RemoveDto;
};


export type MutationRemoveLocationGroupArgs = {
  location_group: RemoveDto;
};


export type MutationRemoveRegionArgs = {
  region: RemoveDto;
};


export type MutationRemoveSensorArgs = {
  sensor: RemoveDto;
};


export type MutationRemoveSiteArgs = {
  site: RemoveDto;
};


export type MutationRemoveStaffArgs = {
  staff: RemoveDto;
};


export type MutationRemoveStaffDepartmentArgs = {
  department_id: Scalars['Int']['input'];
  staff_id: Scalars['Int']['input'];
};


export type MutationRemoveSubBuildingArgs = {
  sub_building: RemoveDto;
};


export type MutationRemoveTagArgs = {
  tag: RemoveDto;
};


export type MutationRemoveUserArgs = {
  user_id: Scalars['String']['input'];
};


export type MutationRemoveWorkflowDepartmentArgs = {
  workflow_department: RemoveDto;
};


export type MutationResetPasswordArgs = {
  user_id: Scalars['String']['input'];
};


export type MutationSensorsBulkArgs = {
  sensors: Array<SensorBulkDto>;
};


export type MutationSiteChangeParentToCustomerArgs = {
  site: SiteChangeParentToCustomerDto;
};


export type MutationSiteChangeParentToDivisionArgs = {
  site: SiteChangeParentToDivisionDto;
};


export type MutationSiteChangeParentToRegionArgs = {
  site: SiteChangeParentToRegionDto;
};


export type MutationStaffBulkArgs = {
  staff: Array<StaffBulkDto>;
};


export type MutationSubBuildingChangeParentArgs = {
  sub_building: SubBuildingChangeParentDto;
};


export type MutationSyncPolestarInfraArgs = {
  input: SyncInfraInput;
};


export type MutationSyncPolestarInfrastructureArgs = {
  payload: SyncInfraRequestInput;
};


export type MutationUpdateBuildingArgs = {
  building: BuildingUpdateDto;
};


export type MutationUpdateCustomerArgs = {
  customer: CustomerUpdateDto;
};


export type MutationUpdateDepartmentArgs = {
  department: DepartmentUpdateDto;
};


export type MutationUpdateDepartmentShiftArgs = {
  departmentShift: DepartmentShiftUpdateDto;
};


export type MutationUpdateDeviceArgs = {
  device: DeviceUpdateDto;
};


export type MutationUpdateDivisionArgs = {
  division: DivisionUpdateDto;
};


export type MutationUpdateFloorArgs = {
  floor: FloorUpdateDto;
};


export type MutationUpdateLocationArgs = {
  location: LocationUpdateDto;
};


export type MutationUpdateLocationGroupArgs = {
  location_group: LocationGroupUpdateDto;
};


export type MutationUpdatePreferencesArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateRegionArgs = {
  region: RegionUpdateDto;
};


export type MutationUpdateRegionDivisionArgs = {
  division: RegionDivisionUpdateDto;
};


export type MutationUpdateSensorArgs = {
  sensor: SensorUpdateDto;
};


export type MutationUpdateSensorCoordinatesArgs = {
  sensor: SensorCoordUpdateDto;
};


export type MutationUpdateSiteArgs = {
  site: SiteUpdateDto;
};


export type MutationUpdateStaffArgs = {
  staff: StaffUpdateDto;
};


export type MutationUpdateStaffTypeArgs = {
  payload: StaffTypeUpdateDto;
};


export type MutationUpdateSubBuildingArgs = {
  sub_building: SubBuildingUpdateDto;
};


export type MutationUpdateTagArgs = {
  tag: TagUpdateDto;
};


export type MutationUpdateUserArgs = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  roles?: InputMaybe<Array<RoleId>>;
};


export type MutationUpdateUserNotificationArgs = {
  user_notification: UserNotificationUpdateDto;
};


export type MutationUsersBulkArgs = {
  users: Array<UserBulkDto>;
};

export type Number_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notbetween?: InputMaybe<Array<Scalars['Float']['input']>>;
  notin?: InputMaybe<Array<Scalars['Float']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PaginatorArgs = {
  page?: Scalars['Int']['input'];
  per_page?: Scalars['Int']['input'];
};

export type PolestarBuilding = {
  __typename?: 'PolestarBuilding';
  caBldgId: Scalars['String']['output'];
  floors?: Maybe<Array<PolestarFloor>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PolestarFloor = {
  __typename?: 'PolestarFloor';
  caFloorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<Array<PolestarZone>>;
};

export type PolestarInfraSyncStatusResponse = {
  __typename?: 'PolestarInfraSyncStatusResponse';
  syncStatus: InfraSyncStatus;
};

export type PolestarInfrastructure = {
  __typename?: 'PolestarInfrastructure';
  batteryStatus?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['Int']['output'];
  deviceCode: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  manufactureName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PolestarInfrastructureFilterInput = {
  batteryStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId: Array<Scalars['Float']['input']>;
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  versions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PolestarInfrastructureView = {
  __typename?: 'PolestarInfrastructureView';
  count: Scalars['Int']['output'];
  filters?: Maybe<Filters>;
  nodes: Array<PolestarInfrastructure>;
  syncStatus?: Maybe<InfraSyncStatus>;
};

export type PolestarSite = {
  __typename?: 'PolestarSite';
  buildings?: Maybe<Array<PolestarBuilding>>;
  caSiteId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PolestarZone = {
  __typename?: 'PolestarZone';
  caZoneId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  availablePickupStations: Array<LocationModel>;
  building: BuildingModel;
  buildings: Array<BuildingModel>;
  /** Get Cisco Floors. */
  ciscoFloors: Array<CiscoFloorModel>;
  currentUser: CurrentUserModel;
  customer_by_domain_id: CustomerPublicModel;
  customer_current: CustomerModel;
  customers: Array<CustomerModel>;
  customers_available: Array<CustomerModel>;
  department?: Maybe<DepartmentModel>;
  departmentShift?: Maybe<DepartmentShiftModel>;
  departmentShifts: Array<DepartmentShiftModel>;
  departments: Array<DepartmentModel>;
  departmentsCount?: Maybe<Aggregate>;
  device?: Maybe<DeviceModel>;
  devices: Array<DeviceModel>;
  devicesCount?: Maybe<Aggregate>;
  division: DivisionModel;
  divisions: Array<DivisionModel>;
  floor: FloorModel;
  floors: Array<FloorModel>;
  getInfrastructureConfiguration: IntegrationConfigModel;
  getPolestarHierarchy: GetHierarchyResponse;
  getPolestarInfrastructureConfiguration: IntegrationConfigModel;
  hhLocationType: HhLocationTypeModel;
  hhLocationTypes: Array<HhLocationTypeModel>;
  hhLocationTypesCount?: Maybe<Aggregate>;
  integration: IntegrationModel;
  integrationsView: IntegrationViewModel;
  locales: Array<LocaleModel>;
  location: LocationModel;
  locationGroup: LocationGroupModel;
  locationGroups: Array<LocationGroupModel>;
  locationGroupsPage: Array<LocationGroupModel>;
  locationTypes: Array<LocationTypeModel>;
  locations: Array<LocationModel>;
  locationsByGroup: Array<LocationModel>;
  locationsCount?: Maybe<Aggregate>;
  locationsPage: Array<LocationModel>;
  polestarInfraSyncStatus: PolestarInfraSyncStatusResponse;
  polestarInfrastructures: Array<PolestarInfrastructure>;
  polestarInfrastructuresView: PolestarInfrastructureView;
  refreshInfrastructureCache: Scalars['Boolean']['output'];
  region: RegionModel;
  regions: Array<RegionModel>;
  regionsCount?: Maybe<Aggregate>;
  rtlsVendor: RtlsVendorModel;
  rtlsVendors: Array<RtlsVendorModel>;
  rtlsVendorsCount?: Maybe<Aggregate>;
  sensor?: Maybe<SensorModel>;
  /** Get coordinates for a single sensor. */
  sensorCoordinates: SensorCoordModel;
  sensors: Array<SensorModel>;
  sensorsCount?: Maybe<Aggregate>;
  site: SiteModel;
  sites: Array<SiteModel>;
  sitesCount?: Maybe<Aggregate>;
  staff: Array<StaffModel>;
  staffCount?: Maybe<Aggregate>;
  staffOne: StaffModel;
  staffType: StaffTypeModel;
  staffTypes: Array<StaffTypeModel>;
  staffTypesCount?: Maybe<Aggregate>;
  staffTypesPage: StaffTypesViewAggregate;
  staffView: StaffViewAggregate;
  subBuilding: SubBuildingModel;
  subBuildings: Array<SubBuildingModel>;
  tag: TagModel;
  tagHistory: Array<TagHistoryModel>;
  tags: Array<TagModel>;
  tagsCount?: Maybe<Aggregate>;
  tagsWithAssignee: Array<TagWithAssigneeModel>;
  tagsWithAssigneeCount?: Maybe<Aggregate>;
  timezone: TimezoneModel;
  timezones: Array<TimezoneModel>;
  timezonesCount?: Maybe<Aggregate>;
  user: UserWithRolesModel;
  userNotification?: Maybe<UserNotificationModel>;
  users: UserListResult;
  workflowDepartments: Array<WorkflowDepartmentModel>;
  workflowDepartmentsCount?: Maybe<Aggregate>;
};


export type QueryAvailablePickupStationsArgs = {
  department_id: Scalars['Float']['input'];
  order_by?: InputMaybe<Array<LocationsResolver_AvailablePickupStations_SortingInputType>>;
};


export type QueryBuildingArgs = {
  where?: InputMaybe<BuildingsResolver_Building_FilterInputType>;
};


export type QueryBuildingsArgs = {
  order_by?: InputMaybe<Array<BuildingsResolver_Buildings_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<BuildingsResolver_Buildings_FilterInputType>;
};


export type QueryCiscoFloorsArgs = {
  siteinfo: SiteInfoDto;
};


export type QueryCustomersArgs = {
  order_by?: InputMaybe<Array<CustomersResolver_Customers_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<CustomersResolver_Customers_FilterInputType>;
};


export type QueryDepartmentArgs = {
  where?: InputMaybe<DepartmentsResolver_Department_FilterInputType>;
};


export type QueryDepartmentShiftArgs = {
  where?: InputMaybe<DepartmentShiftsResolver_DepartmentShift_FilterInputType>;
};


export type QueryDepartmentShiftsArgs = {
  order_by?: InputMaybe<Array<DepartmentShiftsResolver_DepartmentShifts_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<DepartmentShiftsResolver_DepartmentShifts_FilterInputType>;
};


export type QueryDepartmentsArgs = {
  order_by?: InputMaybe<Array<DepartmentsResolver_Departments_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<DepartmentsResolver_Departments_FilterInputType>;
};


export type QueryDepartmentsCountArgs = {
  where?: InputMaybe<DepartmentsResolver_DepartmentsCount_FilterInputType>;
};


export type QueryDeviceArgs = {
  where?: InputMaybe<DevicesResolver_Device_FilterInputType>;
};


export type QueryDevicesArgs = {
  order_by?: InputMaybe<Array<DevicesResolver_Devices_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<DevicesResolver_Devices_FilterInputType>;
};


export type QueryDevicesCountArgs = {
  where?: InputMaybe<DevicesResolver_DevicesCount_FilterInputType>;
};


export type QueryDivisionArgs = {
  where?: InputMaybe<DivisionsResolver_Division_FilterInputType>;
};


export type QueryDivisionsArgs = {
  order_by?: InputMaybe<Array<DivisionsResolver_Divisions_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<DivisionsResolver_Divisions_FilterInputType>;
};


export type QueryFloorArgs = {
  where?: InputMaybe<FloorsResolver_Floor_FilterInputType>;
};


export type QueryFloorsArgs = {
  order_by?: InputMaybe<Array<FloorsResolver_Floors_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<FloorsResolver_Floors_FilterInputType>;
};


export type QueryGetPolestarHierarchyArgs = {
  payload: GetInfraRequestInput;
};


export type QueryHhLocationTypeArgs = {
  where?: InputMaybe<HhLocationTypesResolver_HhLocationType_FilterInputType>;
};


export type QueryHhLocationTypesArgs = {
  order_by?: InputMaybe<Array<HhLocationTypesResolver_HhLocationTypes_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<HhLocationTypesResolver_HhLocationTypes_FilterInputType>;
};


export type QueryHhLocationTypesCountArgs = {
  where?: InputMaybe<HhLocationTypesResolver_HhLocationTypesCount_FilterInputType>;
};


export type QueryIntegrationArgs = {
  where?: InputMaybe<IntegrationsResolver_Integration_FilterInputType>;
};


export type QueryIntegrationsViewArgs = {
  customerid?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IntegrationsResolver_IntegrationsView_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  type?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<IntegrationsResolver_IntegrationsView_FilterInputType>;
};


export type QueryLocalesArgs = {
  order_by?: InputMaybe<Array<LocalesResolver_Locales_SortingInputType>>;
};


export type QueryLocationArgs = {
  where?: InputMaybe<LocationsResolver_Location_FilterInputType>;
};


export type QueryLocationGroupArgs = {
  where?: InputMaybe<LocationGroupsResolver_LocationGroup_FilterInputType>;
};


export type QueryLocationGroupsArgs = {
  order_by?: InputMaybe<Array<LocationGroupsResolver_LocationGroups_SortingInputType>>;
  where?: InputMaybe<LocationGroupsResolver_LocationGroups_FilterInputType>;
};


export type QueryLocationGroupsPageArgs = {
  order_by?: InputMaybe<LocationGroupOrderBy>;
  parent_group_id: Array<Scalars['Int']['input']>;
  site_id: Scalars['Int']['input'];
};


export type QueryLocationTypesArgs = {
  order_by?: InputMaybe<Array<LocationTypesResolver_LocationTypes_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<LocationTypesResolver_LocationTypes_FilterInputType>;
};


export type QueryLocationsArgs = {
  order_by?: InputMaybe<Array<LocationsResolver_Locations_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<LocationsResolver_Locations_FilterInputType>;
};


export type QueryLocationsByGroupArgs = {
  location_group_id: Array<Scalars['Int']['input']>;
  order_by?: InputMaybe<LocationOrderBy>;
  site_id: Scalars['Int']['input'];
};


export type QueryLocationsCountArgs = {
  where?: InputMaybe<LocationsResolver_LocationsCount_FilterInputType>;
};


export type QueryLocationsPageArgs = {
  order_by?: InputMaybe<Array<LocationsResolver_LocationsPage_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<LocationsResolver_LocationsPage_FilterInputType>;
};


export type QueryPolestarInfrastructuresArgs = {
  order_by?: InputMaybe<Array<InfrastructurePolestarResolver_PolestarInfrastructures_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<InfrastructurePolestarResolver_PolestarInfrastructures_FilterInputType>;
};


export type QueryPolestarInfrastructuresViewArgs = {
  filters?: InputMaybe<PolestarInfrastructureFilterInput>;
  order_by?: InputMaybe<Array<InfrastructurePolestarResolver_PolestarInfrastructuresView_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
};


export type QueryRegionArgs = {
  where?: InputMaybe<RegionsResolver_Region_FilterInputType>;
};


export type QueryRegionsArgs = {
  order_by?: InputMaybe<Array<RegionsResolver_Regions_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<RegionsResolver_Regions_FilterInputType>;
};


export type QueryRegionsCountArgs = {
  where?: InputMaybe<RegionsResolver_RegionsCount_FilterInputType>;
};


export type QueryRtlsVendorArgs = {
  where?: InputMaybe<RtlsVendorsResolver_RtlsVendor_FilterInputType>;
};


export type QueryRtlsVendorsArgs = {
  order_by?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendors_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<RtlsVendorsResolver_RtlsVendors_FilterInputType>;
};


export type QueryRtlsVendorsCountArgs = {
  where?: InputMaybe<RtlsVendorsResolver_RtlsVendorsCount_FilterInputType>;
};


export type QuerySensorArgs = {
  where?: InputMaybe<SensorsResolver_Sensor_FilterInputType>;
};


export type QuerySensorCoordinatesArgs = {
  code: Scalars['String']['input'];
};


export type QuerySensorsArgs = {
  order_by?: InputMaybe<Array<SensorsResolver_Sensors_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<SensorsResolver_Sensors_FilterInputType>;
};


export type QuerySensorsCountArgs = {
  where?: InputMaybe<SensorsResolver_SensorsCount_FilterInputType>;
};


export type QuerySiteArgs = {
  where?: InputMaybe<SitesResolver_Site_FilterInputType>;
};


export type QuerySitesArgs = {
  order_by?: InputMaybe<Array<SitesResolver_Sites_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<SitesResolver_Sites_FilterInputType>;
};


export type QuerySitesCountArgs = {
  where?: InputMaybe<SitesResolver_SitesCount_FilterInputType>;
};


export type QueryStaffArgs = {
  order_by?: InputMaybe<Array<StaffResolver_Staff_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<StaffResolver_Staff_FilterInputType>;
};


export type QueryStaffCountArgs = {
  where?: InputMaybe<StaffResolver_StaffCount_FilterInputType>;
};


export type QueryStaffOneArgs = {
  where?: InputMaybe<StaffResolver_StaffOne_FilterInputType>;
};


export type QueryStaffTypeArgs = {
  where?: InputMaybe<StaffTypesResolver_StaffType_FilterInputType>;
};


export type QueryStaffTypesArgs = {
  order_by?: InputMaybe<Array<StaffTypesResolver_StaffTypes_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<StaffTypesResolver_StaffTypes_FilterInputType>;
};


export type QueryStaffTypesCountArgs = {
  where?: InputMaybe<StaffTypesResolver_StaffTypesCount_FilterInputType>;
};


export type QueryStaffTypesPageArgs = {
  order_by?: InputMaybe<Array<StaffTypesResolver_StaffTypesPage_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<StaffTypesResolver_StaffTypesPage_FilterInputType>;
};


export type QueryStaffViewArgs = {
  order_by?: InputMaybe<Array<StaffViewResolver_StaffView_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<StaffViewResolver_StaffView_FilterInputType>;
};


export type QuerySubBuildingArgs = {
  where?: InputMaybe<SubBuildingsResolver_SubBuilding_FilterInputType>;
};


export type QuerySubBuildingsArgs = {
  order_by?: InputMaybe<Array<SubBuildingsResolver_SubBuildings_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<SubBuildingsResolver_SubBuildings_FilterInputType>;
};


export type QueryTagArgs = {
  where?: InputMaybe<TagsResolver_Tag_FilterInputType>;
};


export type QueryTagHistoryArgs = {
  start_time_utc: Scalars['DateTime']['input'];
  stop_time_utc: Scalars['DateTime']['input'];
  tag_id: Scalars['Int']['input'];
};


export type QueryTagsArgs = {
  order_by?: InputMaybe<Array<TagsResolver_Tags_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<TagsResolver_Tags_FilterInputType>;
};


export type QueryTagsCountArgs = {
  where?: InputMaybe<TagsResolver_TagsCount_FilterInputType>;
};


export type QueryTagsWithAssigneeArgs = {
  order_by?: InputMaybe<Array<TagsWithAssigneeResolver_TagsWithAssignee_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<TagsWithAssigneeResolver_TagsWithAssignee_FilterInputType>;
};


export type QueryTagsWithAssigneeCountArgs = {
  where?: InputMaybe<TagsWithAssigneeResolver_TagsWithAssigneeCount_FilterInputType>;
};


export type QueryTimezoneArgs = {
  where?: InputMaybe<TimezonesResolver_Timezone_FilterInputType>;
};


export type QueryTimezonesArgs = {
  order_by?: InputMaybe<Array<TimezonesResolver_Timezones_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<TimezonesResolver_Timezones_FilterInputType>;
};


export type QueryTimezonesCountArgs = {
  where?: InputMaybe<TimezonesResolver_TimezonesCount_FilterInputType>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Float']['input'];
  per_page: Scalars['Float']['input'];
};


export type QueryWorkflowDepartmentsArgs = {
  order_by?: InputMaybe<Array<WorkflowDepartmentsResolver_WorkflowDepartments_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<WorkflowDepartmentsResolver_WorkflowDepartments_FilterInputType>;
};


export type QueryWorkflowDepartmentsCountArgs = {
  where?: InputMaybe<WorkflowDepartmentsResolver_WorkflowDepartmentsCount_FilterInputType>;
};

export type RegionCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type RegionDivisionCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region_id: Scalars['Int']['input'];
};

export type RegionDivisionUpdateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RegionHierarchyUnion = DivisionModel | SiteModel;

export type RegionModel = {
  __typename?: 'RegionModel';
  children: Array<RegionHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  crm_account_id?: Maybe<Scalars['String']['output']>;
  crm_site_id?: Maybe<Scalars['String']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type RegionSiteCreateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  default_timezone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  region_id: Scalars['Int']['input'];
};

export type RegionUpdateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type RegionsResolver_RegionFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_Region_FilterInputType = {
  and?: InputMaybe<Array<RegionsResolver_RegionFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RegionsResolver_RegionFilterInputType>>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_RegionsCountFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_RegionsCount_FilterInputType = {
  and?: InputMaybe<Array<RegionsResolver_RegionsCountFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RegionsResolver_RegionsCountFilterInputType>>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_RegionsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_Regions_FilterInputType = {
  and?: InputMaybe<Array<RegionsResolver_RegionsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RegionsResolver_RegionsFilterInputType>>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type RegionsResolver_Regions_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  crm_account_id?: InputMaybe<SortType>;
  crm_site_id?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type RemoveDto = {
  id: Scalars['Int']['input'];
};

export type RemoveModel = {
  __typename?: 'RemoveModel';
  customer_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export enum RoleId {
  ArtAdmin = 'ART__Admin',
  ArtManager = 'ART__Manager',
  ArtUser = 'ART__User',
  CaAdmin = 'CA__Admin',
  CaOwner = 'CA__Owner',
  DrtAdmin = 'DRT__Admin',
  DrtClinicalStaff = 'DRT__Clinical_Staff',
  DrtManager = 'DRT__Manager',
  DrtSecurityOfficer = 'DRT__Security_Officer',
  HhManager = 'HH__Manager',
  HhOwner = 'HH__Owner',
  HhUser = 'HH__User',
  MmManager = 'MM__Manager',
  MmUser = 'MM__User',
  SuperAdmin = 'Super_Admin',
  WrtAdmin = 'WRT__Admin',
  WrtManager = 'WRT__Manager',
  WrtOwner = 'WRT__Owner',
  WrtUser = 'WRT__User'
}

export type RtlsVendorModel = {
  __typename?: 'RtlsVendorModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RtlsVendorsResolver_RtlsVendorFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type RtlsVendorsResolver_RtlsVendor_FilterInputType = {
  and?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorFilterInputType>>;
};

export type RtlsVendorsResolver_RtlsVendorsCountFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type RtlsVendorsResolver_RtlsVendorsCount_FilterInputType = {
  and?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorsCountFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorsCountFilterInputType>>;
};

export type RtlsVendorsResolver_RtlsVendorsFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
};

export type RtlsVendorsResolver_RtlsVendors_FilterInputType = {
  and?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorsFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<RtlsVendorsResolver_RtlsVendorsFilterInputType>>;
};

export type RtlsVendorsResolver_RtlsVendors_SortingInputType = {
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
};

export type SensorBulkDto = {
  correlation_id?: InputMaybe<Scalars['String']['input']>;
  dispenser_type_id?: InputMaybe<Scalars['Int']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location_id: Scalars['Int']['input'];
  rtls_vendor_id: Scalars['String']['input'];
  sensor_type_id: Scalars['Int']['input'];
  sensor_value: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type SensorBulkOperationError = {
  __typename?: 'SensorBulkOperationError';
  entity?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['JSONObject']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['JSONObject']['output']>;
  masterEntity?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
  sensor?: Maybe<Scalars['JSONObject']['output']>;
};

export type SensorCoordModel = {
  __typename?: 'SensorCoordModel';
  /** Sensor's hardware ID */
  code: Scalars['String']['output'];
  /** Sensor's Device Type */
  deviceType: Scalars['String']['output'];
  /** Sensor's coordinates (latitude) */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Sensor's coordinates (longitude) */
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type SensorCoordUpdateDto = {
  /** Sensor's hardware ID */
  code: Scalars['String']['input'];
  /** Sensor's Device Type */
  deviceType: Scalars['String']['input'];
  /** Sensor's coordinates (latitude) */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Sensor's coordinates (longitude) */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type SensorCreateDto = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  location_id: Scalars['Int']['input'];
  rtls_vendor_id: Scalars['String']['input'];
  sensor_value: Scalars['String']['input'];
};

export type SensorModel = {
  __typename?: 'SensorModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location: LocationModel;
  location_id: Scalars['Int']['output'];
  low_battery_since_utc?: Maybe<Scalars['DateTime']['output']>;
  rtls_vendor_id: Scalars['String']['output'];
  sensor_type_id: Scalars['Int']['output'];
  sensor_value: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type SensorUpdateDto = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
  rtls_vendor_id?: InputMaybe<Scalars['String']['input']>;
  sensor_value?: InputMaybe<Scalars['String']['input']>;
};

export type SensorsResolver_SensorFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SensorsResolver_Sensor_FilterInputType = {
  and?: InputMaybe<Array<SensorsResolver_SensorFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  or?: InputMaybe<Array<SensorsResolver_SensorFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SensorsResolver_SensorsCountFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SensorsResolver_SensorsCount_FilterInputType = {
  and?: InputMaybe<Array<SensorsResolver_SensorsCountFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  or?: InputMaybe<Array<SensorsResolver_SensorsCountFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SensorsResolver_SensorsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Number_PropertyFilterInputType>;
};

export type SensorsResolver_Sensors_FilterInputType = {
  and?: InputMaybe<Array<SensorsResolver_SensorsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  location_id?: InputMaybe<Int_PropertyFilterInputType>;
  low_battery_since_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  or?: InputMaybe<Array<SensorsResolver_SensorsFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensor_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  sensor_value?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Number_PropertyFilterInputType>;
};

export type SensorsResolver_Sensors_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  display_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  locationName?: InputMaybe<SortType>;
  location_id?: InputMaybe<SortType>;
  low_battery_since_utc?: InputMaybe<SortType>;
  rtls_vendor_id?: InputMaybe<SortType>;
  sensor_type_id?: InputMaybe<SortType>;
  sensor_value?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type SiteChangeParentToCustomerDto = {
  id: Scalars['Int']['input'];
};

export type SiteChangeParentToDivisionDto = {
  division_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type SiteChangeParentToRegionDto = {
  id: Scalars['Int']['input'];
  region_id: Scalars['Int']['input'];
};

export type SiteFloorCreateDto = {
  name: Scalars['String']['input'];
  site_id: Scalars['Int']['input'];
};

export type SiteHierarchyUnion = BuildingModel | FloorModel | SubBuildingModel;

export type SiteInfoDto = {
  /** Pulse Site Id */
  PulseSiteId: Scalars['String']['input'];
};

export type SiteModel = {
  __typename?: 'SiteModel';
  children: Array<SiteHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  crm_account_id?: Maybe<Scalars['String']['output']>;
  crm_site_id?: Maybe<Scalars['String']['output']>;
  customer_id: Scalars['Int']['output'];
  default_timezone: Scalars['String']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  departments: Array<DepartmentModel>;
  departments_count?: Maybe<Scalars['Int']['output']>;
  division_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  locations: Array<LocationModel>;
  locations_count?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteModelDepartmentsArgs = {
  order_by?: InputMaybe<Array<SitesResolver_Departments_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<SitesResolver_Departments_FilterInputType>;
};


export type SiteModelLocationsArgs = {
  order_by?: InputMaybe<Array<SitesResolver_Locations_SortingInputType>>;
  paginate?: InputMaybe<PaginatorArgs>;
  where?: InputMaybe<SitesResolver_Locations_FilterInputType>;
};

export type SiteRequestInput = {
  buildings?: InputMaybe<Array<BuildingRequestInput>>;
  deletBeforeSync: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type SiteUpdateDto = {
  crm_account_id?: InputMaybe<Scalars['String']['input']>;
  crm_site_id?: InputMaybe<Scalars['String']['input']>;
  default_timezone?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SitesResolver_DepartmentsFilterInputType = {
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type SitesResolver_Departments_FilterInputType = {
  and?: InputMaybe<Array<SitesResolver_DepartmentsFilterInputType>>;
  announcement_text?: InputMaybe<String_PropertyFilterInputType>;
  appointment_confirmation_message?: InputMaybe<String_PropertyFilterInputType>;
  auto_checkout_configuration?: InputMaybe<JsonObject_PropertyFilterInputType>;
  care_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  operating_hours?: InputMaybe<Json_PropertyFilterInputType>;
  or?: InputMaybe<Array<SitesResolver_DepartmentsFilterInputType>>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  waiting_table_configuration?: InputMaybe<String_PropertyFilterInputType>;
};

export type SitesResolver_Departments_SortingInputType = {
  announcement_text?: InputMaybe<SortType>;
  appointment_confirmation_message?: InputMaybe<SortType>;
  auto_checkout_configuration?: InputMaybe<SortType>;
  care_table_configuration?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  operating_hours?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
  waiting_table_configuration?: InputMaybe<SortType>;
};

export type SitesResolver_LocationsFilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_Locations_FilterInputType = {
  alias_name?: InputMaybe<String_PropertyFilterInputType>;
  and?: InputMaybe<Array<SitesResolver_LocationsFilterInputType>>;
  asset_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  boundary?: InputMaybe<JsonObject_PropertyFilterInputType>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  department_ids?: InputMaybe<Int_PropertyFilterInputType>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  floor_id?: InputMaybe<Int_PropertyFilterInputType>;
  hh_location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  is_non_reporting?: InputMaybe<Boolean_PropertyFilterInputType>;
  is_zone?: InputMaybe<Boolean_PropertyFilterInputType>;
  location_group_id?: InputMaybe<Int_PropertyFilterInputType>;
  location_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SitesResolver_LocationsFilterInputType>>;
  parent_name?: InputMaybe<String_PropertyFilterInputType>;
  sensors_ids?: InputMaybe<String_PropertyFilterInputType>;
  shape_id?: InputMaybe<String_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_Locations_SortingInputType = {
  alias_name?: InputMaybe<SortType>;
  asset_location_type_id?: InputMaybe<SortType>;
  boundary?: InputMaybe<SortType>;
  building_id?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  department_ids?: InputMaybe<SortType>;
  department_names?: InputMaybe<SortType>;
  floor_id?: InputMaybe<SortType>;
  hh_location_type_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  is_non_reporting?: InputMaybe<SortType>;
  is_zone?: InputMaybe<SortType>;
  location_group_id?: InputMaybe<SortType>;
  location_type_id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_name?: InputMaybe<SortType>;
  sensors_ids?: InputMaybe<SortType>;
  shape_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type SitesResolver_SiteFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_Site_FilterInputType = {
  and?: InputMaybe<Array<SitesResolver_SiteFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SitesResolver_SiteFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_SitesCountFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_SitesCount_FilterInputType = {
  and?: InputMaybe<Array<SitesResolver_SitesCountFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SitesResolver_SitesCountFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_SitesFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_Sites_FilterInputType = {
  and?: InputMaybe<Array<SitesResolver_SitesFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  crm_account_id?: InputMaybe<String_PropertyFilterInputType>;
  crm_site_id?: InputMaybe<String_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  default_timezone?: InputMaybe<String_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  departments_count?: InputMaybe<Int_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  locations_count?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SitesResolver_SitesFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SitesResolver_Sites_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  crm_account_id?: InputMaybe<SortType>;
  crm_site_id?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  default_timezone?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  departments_count?: InputMaybe<SortType>;
  division_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  locations_count?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  region_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export enum SortType {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type StaffBulkDto = {
  department_ids?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  secured_staff_name?: InputMaybe<Scalars['String']['input']>;
  staff_type_id: Scalars['Float']['input'];
  tag_value?: InputMaybe<Scalars['String']['input']>;
};

export type StaffBulkOperationError = {
  __typename?: 'StaffBulkOperationError';
  entity?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['JSONObject']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  masterEntity?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
};

export type StaffCreateDto = {
  department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  secured_staff_name?: InputMaybe<Scalars['String']['input']>;
  staff_type_id: Scalars['Int']['input'];
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  tag_value?: InputMaybe<Scalars['String']['input']>;
};

export type StaffModel = {
  __typename?: 'StaffModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  departments: Array<DepartmentModel>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  location?: Maybe<LocationModel>;
  phone_number?: Maybe<Scalars['String']['output']>;
  secured_staff_name?: Maybe<Scalars['String']['output']>;
  staff_type: StaffTypeModel;
  staff_type_id: Scalars['Int']['output'];
  tag?: Maybe<TagModel>;
  tag_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffResolver_StaffCountFilterInputType = {
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_StaffCount_FilterInputType = {
  and?: InputMaybe<Array<StaffResolver_StaffCountFilterInputType>>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffResolver_StaffCountFilterInputType>>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_StaffFilterInputType = {
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_StaffOneFilterInputType = {
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_StaffOne_FilterInputType = {
  and?: InputMaybe<Array<StaffResolver_StaffOneFilterInputType>>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffResolver_StaffOneFilterInputType>>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_Staff_FilterInputType = {
  and?: InputMaybe<Array<StaffResolver_StaffFilterInputType>>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffResolver_StaffFilterInputType>>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffResolver_Staff_SortingInputType = {
  email?: InputMaybe<SortType>;
  first_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  last_name?: InputMaybe<SortType>;
  phone_number?: InputMaybe<SortType>;
  secured_staff_name?: InputMaybe<SortType>;
  staff_type_id?: InputMaybe<SortType>;
  tag_id?: InputMaybe<SortType>;
  tag_value?: InputMaybe<SortType>;
};

export type StaffTypeModel = {
  __typename?: 'StaffTypeModel';
  display_name: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  icon_acronym?: Maybe<Scalars['String']['output']>;
  icon_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent_staff_type?: Maybe<StaffTypeModel>;
  parent_staff_type_id?: Maybe<Scalars['Int']['output']>;
};

export type StaffTypeUpdateDto = {
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_acronym?: InputMaybe<Scalars['String']['input']>;
  icon_color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type StaffTypesResolver_StaffTypeFilterInputType = {
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffType_FilterInputType = {
  and?: InputMaybe<Array<StaffTypesResolver_StaffTypeFilterInputType>>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffTypesResolver_StaffTypeFilterInputType>>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesCountFilterInputType = {
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesCount_FilterInputType = {
  and?: InputMaybe<Array<StaffTypesResolver_StaffTypesCountFilterInputType>>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffTypesResolver_StaffTypesCountFilterInputType>>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesFilterInputType = {
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesPageFilterInputType = {
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesPage_FilterInputType = {
  and?: InputMaybe<Array<StaffTypesResolver_StaffTypesPageFilterInputType>>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffTypesResolver_StaffTypesPageFilterInputType>>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypesPage_SortingInputType = {
  display_name?: InputMaybe<SortType>;
  icon?: InputMaybe<SortType>;
  icon_acronym?: InputMaybe<SortType>;
  icon_color?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_staff_type_id?: InputMaybe<SortType>;
};

export type StaffTypesResolver_StaffTypes_FilterInputType = {
  and?: InputMaybe<Array<StaffTypesResolver_StaffTypesFilterInputType>>;
  display_name?: InputMaybe<String_PropertyFilterInputType>;
  icon?: InputMaybe<String_PropertyFilterInputType>;
  icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  icon_color?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffTypesResolver_StaffTypesFilterInputType>>;
  parent_staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
};

export type StaffTypesResolver_StaffTypes_SortingInputType = {
  display_name?: InputMaybe<SortType>;
  icon?: InputMaybe<SortType>;
  icon_acronym?: InputMaybe<SortType>;
  icon_color?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  parent_staff_type_id?: InputMaybe<SortType>;
};

export type StaffTypesViewAggregate = {
  __typename?: 'StaffTypesViewAggregate';
  count: Scalars['Int']['output'];
  nodes: Array<StaffTypeModel>;
};

export type StaffUpdateDto = {
  department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  last_name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  secured_staff_name?: InputMaybe<Scalars['String']['input']>;
  staff_type_id: Scalars['Int']['input'];
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  tag_value?: InputMaybe<Scalars['String']['input']>;
};

export type StaffViewAggregate = {
  __typename?: 'StaffViewAggregate';
  count: Scalars['Int']['output'];
  nodes: Array<StaffViewModel>;
};

export type StaffViewModel = {
  __typename?: 'StaffViewModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  department_names?: Maybe<Scalars['String']['output']>;
  departments: Array<DepartmentModel>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  location?: Maybe<LocationModel>;
  phone_number?: Maybe<Scalars['String']['output']>;
  secured_staff_name?: Maybe<Scalars['String']['output']>;
  staff_type: StaffTypeModel;
  staff_type_display_name: Scalars['String']['output'];
  staff_type_icon?: Maybe<Scalars['String']['output']>;
  staff_type_icon_acronym?: Maybe<Scalars['String']['output']>;
  staff_type_icon_color?: Maybe<Scalars['String']['output']>;
  staff_type_id: Scalars['Int']['output'];
  tag?: Maybe<TagModel>;
  tag_id?: Maybe<Scalars['Int']['output']>;
  tag_value?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffViewResolver_StaffViewFilterInputType = {
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_display_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon_color?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffViewResolver_StaffView_FilterInputType = {
  and?: InputMaybe<Array<StaffViewResolver_StaffViewFilterInputType>>;
  department_names?: InputMaybe<String_PropertyFilterInputType>;
  email?: InputMaybe<String_PropertyFilterInputType>;
  first_name?: InputMaybe<String_PropertyFilterInputType>;
  full_name?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  last_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<StaffViewResolver_StaffViewFilterInputType>>;
  phone_number?: InputMaybe<String_PropertyFilterInputType>;
  secured_staff_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_display_name?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon_acronym?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_icon_color?: InputMaybe<String_PropertyFilterInputType>;
  staff_type_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_id?: InputMaybe<Int_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
};

export type StaffViewResolver_StaffView_SortingInputType = {
  department_names?: InputMaybe<SortType>;
  email?: InputMaybe<SortType>;
  first_name?: InputMaybe<SortType>;
  full_name?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  last_name?: InputMaybe<SortType>;
  phone_number?: InputMaybe<SortType>;
  secured_staff_name?: InputMaybe<SortType>;
  staff_type_display_name?: InputMaybe<SortType>;
  staff_type_icon?: InputMaybe<SortType>;
  staff_type_icon_acronym?: InputMaybe<SortType>;
  staff_type_icon_color?: InputMaybe<SortType>;
  staff_type_id?: InputMaybe<SortType>;
  tag_id?: InputMaybe<SortType>;
  tag_value?: InputMaybe<SortType>;
};

export type String_PropertyFilterInputType = {
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notbetween?: InputMaybe<Array<Scalars['String']['input']>>;
  notin?: InputMaybe<Array<Scalars['String']['input']>>;
  notlike?: InputMaybe<Scalars['String']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubBuildingChangeParentDto = {
  building_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type SubBuildingCreateDto = {
  building_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type SubBuildingFloorCreateDto = {
  name: Scalars['String']['input'];
  sub_building_id: Scalars['Int']['input'];
};

export type SubBuildingHierarchyUnion = FloorModel;

export type SubBuildingModel = {
  __typename?: 'SubBuildingModel';
  building: BuildingModel;
  building_id: Scalars['Int']['output'];
  children: Array<SubBuildingHierarchyUnion>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  division_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
  site_id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type SubBuildingUpdateDto = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type SubBuildingsResolver_SubBuildingFilterInputType = {
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SubBuildingsResolver_SubBuilding_FilterInputType = {
  and?: InputMaybe<Array<SubBuildingsResolver_SubBuildingFilterInputType>>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SubBuildingsResolver_SubBuildingFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SubBuildingsResolver_SubBuildingsFilterInputType = {
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SubBuildingsResolver_SubBuildings_FilterInputType = {
  and?: InputMaybe<Array<SubBuildingsResolver_SubBuildingsFilterInputType>>;
  building_id?: InputMaybe<Int_PropertyFilterInputType>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  division_id?: InputMaybe<Int_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<SubBuildingsResolver_SubBuildingsFilterInputType>>;
  region_id?: InputMaybe<Int_PropertyFilterInputType>;
  site_id?: InputMaybe<Int_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type SubBuildingsResolver_SubBuildings_SortingInputType = {
  building_id?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  division_id?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  name?: InputMaybe<SortType>;
  region_id?: InputMaybe<SortType>;
  site_id?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type SyncHierarchyResponse = {
  __typename?: 'SyncHierarchyResponse';
  sites?: Maybe<Array<PolestarSite>>;
  statusCode: Scalars['Float']['output'];
  statusMessage: Scalars['String']['output'];
};

export type SyncInfraInput = {
  siteIds: Array<Scalars['String']['input']>;
};

export type SyncInfraRequestInput = {
  site: Array<SiteRequestInput>;
};

export type SyncInfraResponse = {
  __typename?: 'SyncInfraResponse';
  statusCode: Scalars['Int']['output'];
  statusMessage: Scalars['String']['output'];
};

export type TagCreateDto = {
  expiration_utc?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  rtls_vendor_id: Scalars['String']['input'];
  tag_value: Scalars['String']['input'];
};

export type TagHistoryModel = {
  __typename?: 'TagHistoryModel';
  id: Scalars['Int']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
  sensor_value?: Maybe<Scalars['String']['output']>;
  start_time_utc: Scalars['DateTime']['output'];
  stop_time_utc?: Maybe<Scalars['DateTime']['output']>;
  time_in_location?: Maybe<Scalars['JSONObject']['output']>;
};

export type TagModel = {
  __typename?: 'TagModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  current_location_id?: Maybe<Scalars['Int']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  expiration_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationModel>;
  rtlsVendor: RtlsVendorModel;
  rtls_vendor_id: Scalars['String']['output'];
  sensed_utc?: Maybe<Scalars['DateTime']['output']>;
  tag_value: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type TagUpdateDto = {
  expiration_utc?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  rtls_vendor_id: Scalars['String']['input'];
  tag_value?: InputMaybe<Scalars['String']['input']>;
};

export type TagWithAssigneeModel = {
  __typename?: 'TagWithAssigneeModel';
  assignee?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  current_tag_location_sensed_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  expiration_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  location_display_name?: Maybe<Scalars['String']['output']>;
  low_battery_since_utc?: Maybe<Scalars['DateTime']['output']>;
  non_reporting_since_utc?: Maybe<Scalars['DateTime']['output']>;
  rtls_vendor_id: Scalars['String']['output'];
  sensed_utc?: Maybe<Scalars['DateTime']['output']>;
  tag_value: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type TagsResolver_TagFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_Tag_FilterInputType = {
  and?: InputMaybe<Array<TagsResolver_TagFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TagsResolver_TagFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_TagsCountFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_TagsCount_FilterInputType = {
  and?: InputMaybe<Array<TagsResolver_TagsCountFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TagsResolver_TagsCountFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_TagsFilterInputType = {
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_Tags_FilterInputType = {
  and?: InputMaybe<Array<TagsResolver_TagsFilterInputType>>;
  created_by?: InputMaybe<String_PropertyFilterInputType>;
  created_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  current_location_id?: InputMaybe<Int_PropertyFilterInputType>;
  customer_id?: InputMaybe<Int_PropertyFilterInputType>;
  deleted_by?: InputMaybe<String_PropertyFilterInputType>;
  deleted_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TagsResolver_TagsFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  sensed_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  updated_by?: InputMaybe<String_PropertyFilterInputType>;
  updated_utc?: InputMaybe<DateTime_PropertyFilterInputType>;
};

export type TagsResolver_Tags_SortingInputType = {
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  current_location_id?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  expiration_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  label?: InputMaybe<SortType>;
  rtls_vendor_id?: InputMaybe<SortType>;
  sensed_utc?: InputMaybe<SortType>;
  tag_value?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
};

export type TagsWithAssigneeResolver_TagsWithAssigneeCountFilterInputType = {
  assignee?: InputMaybe<String_PropertyFilterInputType>;
  current_tag_location_sensed_utc?: InputMaybe<String_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  location_display_name?: InputMaybe<String_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  vendor?: InputMaybe<String_PropertyFilterInputType>;
};

export type TagsWithAssigneeResolver_TagsWithAssigneeCount_FilterInputType = {
  and?: InputMaybe<Array<TagsWithAssigneeResolver_TagsWithAssigneeCountFilterInputType>>;
  assignee?: InputMaybe<String_PropertyFilterInputType>;
  current_tag_location_sensed_utc?: InputMaybe<String_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  location_display_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TagsWithAssigneeResolver_TagsWithAssigneeCountFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  vendor?: InputMaybe<String_PropertyFilterInputType>;
};

export type TagsWithAssigneeResolver_TagsWithAssigneeFilterInputType = {
  assignee?: InputMaybe<String_PropertyFilterInputType>;
  current_tag_location_sensed_utc?: InputMaybe<String_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  location_display_name?: InputMaybe<String_PropertyFilterInputType>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  vendor?: InputMaybe<String_PropertyFilterInputType>;
};

export type TagsWithAssigneeResolver_TagsWithAssignee_FilterInputType = {
  and?: InputMaybe<Array<TagsWithAssigneeResolver_TagsWithAssigneeFilterInputType>>;
  assignee?: InputMaybe<String_PropertyFilterInputType>;
  current_tag_location_sensed_utc?: InputMaybe<String_PropertyFilterInputType>;
  expiration_utc?: InputMaybe<String_PropertyFilterInputType>;
  id?: InputMaybe<Int_PropertyFilterInputType>;
  label?: InputMaybe<String_PropertyFilterInputType>;
  location_display_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TagsWithAssigneeResolver_TagsWithAssigneeFilterInputType>>;
  rtls_vendor_id?: InputMaybe<String_PropertyFilterInputType>;
  tag_value?: InputMaybe<String_PropertyFilterInputType>;
  vendor?: InputMaybe<String_PropertyFilterInputType>;
};

export type TagsWithAssigneeResolver_TagsWithAssignee_SortingInputType = {
  assignee?: InputMaybe<SortType>;
  created_by?: InputMaybe<SortType>;
  created_utc?: InputMaybe<SortType>;
  current_tag_location_sensed_utc?: InputMaybe<SortType>;
  customer_id?: InputMaybe<SortType>;
  deleted_by?: InputMaybe<SortType>;
  deleted_utc?: InputMaybe<SortType>;
  expiration_utc?: InputMaybe<SortType>;
  id?: InputMaybe<SortType>;
  label?: InputMaybe<SortType>;
  location_display_name?: InputMaybe<SortType>;
  low_battery_since_utc?: InputMaybe<SortType>;
  non_reporting_since_utc?: InputMaybe<SortType>;
  rtls_vendor_id?: InputMaybe<SortType>;
  sensed_utc?: InputMaybe<SortType>;
  tag_value?: InputMaybe<SortType>;
  updated_by?: InputMaybe<SortType>;
  updated_utc?: InputMaybe<SortType>;
  vendor?: InputMaybe<SortType>;
};

export type TimezoneModel = {
  __typename?: 'TimezoneModel';
  id: Scalars['String']['output'];
};

export type TimezonesResolver_TimezoneFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
};

export type TimezonesResolver_Timezone_FilterInputType = {
  and?: InputMaybe<Array<TimezonesResolver_TimezoneFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TimezonesResolver_TimezoneFilterInputType>>;
};

export type TimezonesResolver_TimezonesCountFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
};

export type TimezonesResolver_TimezonesCount_FilterInputType = {
  and?: InputMaybe<Array<TimezonesResolver_TimezonesCountFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TimezonesResolver_TimezonesCountFilterInputType>>;
};

export type TimezonesResolver_TimezonesFilterInputType = {
  id?: InputMaybe<String_PropertyFilterInputType>;
};

export type TimezonesResolver_Timezones_FilterInputType = {
  and?: InputMaybe<Array<TimezonesResolver_TimezonesFilterInputType>>;
  id?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<TimezonesResolver_TimezonesFilterInputType>>;
};

export type TimezonesResolver_Timezones_SortingInputType = {
  id?: InputMaybe<SortType>;
};

export type UserBulkDto = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  roles: Array<Scalars['Int']['input']>;
};

export type UserBulkOperationError = {
  __typename?: 'UserBulkOperationError';
  entity?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['JSONObject']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
};

export type UserListItemModel = {
  __typename?: 'UserListItemModel';
  email: Scalars['String']['output'];
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type UserListResult = {
  __typename?: 'UserListResult';
  length: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  users: Array<UserListItemModel>;
};

export type UserNotificationCreateDto = {
  expiration_utc: Scalars['DateTime']['input'];
  notification_message: Scalars['String']['input'];
  notification_title: Scalars['String']['input'];
};

export type UserNotificationModel = {
  __typename?: 'UserNotificationModel';
  created_utc: Scalars['DateTime']['output'];
  expiration_utc: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  notification_message: Scalars['String']['output'];
  notification_title: Scalars['String']['output'];
};

export type UserNotificationUpdateDto = {
  expiration_utc?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  notification_message?: InputMaybe<Scalars['String']['input']>;
  notification_title?: InputMaybe<Scalars['String']['input']>;
};

export type UserWithRolesModel = {
  __typename?: 'UserWithRolesModel';
  email: Scalars['String']['output'];
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  user_id: Scalars['String']['output'];
};

export type WorkflowDepartmentCreateDto = {
  department_id: Scalars['Int']['input'];
};

export type WorkflowDepartmentModel = {
  __typename?: 'WorkflowDepartmentModel';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  department: DepartmentModel;
  department_id: Scalars['Int']['output'];
  displayBoardsCountByType: Array<DisplayBoardsCountByType>;
  id: Scalars['Int']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
  workflowsCountByType: Array<WorkflowsCountByType>;
};

export type WorkflowDepartmentsResolver_WorkflowDepartmentsCountFilterInputType = {
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  department_name?: InputMaybe<String_PropertyFilterInputType>;
  site_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type WorkflowDepartmentsResolver_WorkflowDepartmentsCount_FilterInputType = {
  and?: InputMaybe<Array<WorkflowDepartmentsResolver_WorkflowDepartmentsCountFilterInputType>>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  department_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<WorkflowDepartmentsResolver_WorkflowDepartmentsCountFilterInputType>>;
  site_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type WorkflowDepartmentsResolver_WorkflowDepartmentsFilterInputType = {
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  department_name?: InputMaybe<String_PropertyFilterInputType>;
  site_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type WorkflowDepartmentsResolver_WorkflowDepartments_FilterInputType = {
  and?: InputMaybe<Array<WorkflowDepartmentsResolver_WorkflowDepartmentsFilterInputType>>;
  department_id?: InputMaybe<Int_PropertyFilterInputType>;
  department_name?: InputMaybe<String_PropertyFilterInputType>;
  or?: InputMaybe<Array<WorkflowDepartmentsResolver_WorkflowDepartmentsFilterInputType>>;
  site_name?: InputMaybe<String_PropertyFilterInputType>;
};

export type WorkflowDepartmentsResolver_WorkflowDepartments_SortingInputType = {
  department_id?: InputMaybe<SortType>;
  department_name?: InputMaybe<SortType>;
  site_name?: InputMaybe<SortType>;
};

export type WorkflowsCountByType = {
  __typename?: 'WorkflowsCountByType';
  count: Scalars['Float']['output'];
  customer_id: Scalars['Float']['output'];
  department_id: Scalars['Float']['output'];
  workflow_type_id: Scalars['Float']['output'];
};

export type ZoneRequestInput = {
  deletBeforeSync: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type CustomersAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomersAvailableQuery = { __typename?: 'Query', customers_available: Array<{ __typename?: 'CustomerModel', id: number, subdomain: string, fullName: string, aliasName: string, crmAccountId?: string | null, crmSiteId?: string | null }> };

export type CurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCustomerQuery = { __typename?: 'Query', customer_current: { __typename?: 'CustomerModel', id: number, subdomain: string, fullName: string, aliasName: string, defaultTimezone: string, crmAccountId?: string | null, crmSiteId?: string | null, isAdEnabled: boolean, licenseInfo?: any | null, autoLogoutSeconds: number, locale: { __typename?: 'LocaleModel', locale: string } } };

export type CustomerForCurrentDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerForCurrentDomainQuery = { __typename?: 'Query', customer_by_domain_id: { __typename?: 'CustomerPublicModel', id: number, authOrgId?: string | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUserModel', id: string, fullName: string, email: string, preferences?: any | null, firstName?: string | null, lastName?: string | null } };

export const CustomersAvailableDocument = gql`
    query CustomersAvailable {
  customers_available {
    id
    fullName: full_name
    aliasName: alias_name
    subdomain
    crmAccountId: crm_account_id
    crmSiteId: crm_site_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomersAvailableGQL extends Apollo.Query<CustomersAvailableQuery, CustomersAvailableQueryVariables> {
    override document = CustomersAvailableDocument;
    override client = 'CA';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentCustomerDocument = gql`
    query CurrentCustomer {
  customer_current {
    id
    fullName: full_name
    aliasName: alias_name
    subdomain
    defaultTimezone: default_timezone
    crmAccountId: crm_account_id
    crmSiteId: crm_site_id
    isAdEnabled: is_ad_enabled
    licenseInfo: license_info
    autoLogoutSeconds: auto_logout_seconds
    locale {
      locale
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentCustomerGQL extends Apollo.Query<CurrentCustomerQuery, CurrentCustomerQueryVariables> {
    override document = CurrentCustomerDocument;
    override client = 'CA';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerForCurrentDomainDocument = gql`
    query CustomerForCurrentDomain {
  customer_by_domain_id {
    id
    authOrgId: auth_org_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerForCurrentDomainGQL extends Apollo.Query<CustomerForCurrentDomainQuery, CustomerForCurrentDomainQueryVariables> {
    override document = CustomerForCurrentDomainDocument;
    override client = 'CA';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    firstName: first_name
    lastName: last_name
    fullName @client
    email
    preferences
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    override document = CurrentUserDocument;
    override client = 'CA';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }